<template>
  <ExpenseReceiptDetailTabDetail
    v-if="activeTab === 'detail'"
    :expense-receipt="expenseReceipt"
  />

  <ExpenseReceiptDetailTabShipping
    v-else-if="activeTab === 'shipping'"
    :expense-receipt="expenseReceipt"
  />

  <ExpenseReceiptDetailTabDocuments
    v-else-if="activeTab === 'documents'"
    :expense-receipt="expenseReceipt"
  />

  <ExpenseReceiptDetailTabHistory
    v-else-if="activeTab === 'history'"
    :expense-receipt="expenseReceipt"
  />

  <ExpenseReceiptDetailTabDetail
    v-else
    :expense-receipt="expenseReceipt"
  />
</template>

<script>
import ExpenseReceiptDetailTabDetail from '@/components/expenseReceipts/detail/tabs/ExpenseReceiptDetailTabDetail.vue';
import ExpenseReceiptDetailTabShipping from '@/components/expenseReceipts/detail/tabs/ExpenseReceiptDetailTabShipping.vue';
import ExpenseReceiptDetailTabDocuments from '@/components/expenseReceipts/detail/tabs/ExpenseReceiptDetailTabDocuments.vue';
import ExpenseReceiptDetailTabHistory from '@/components/expenseReceipts/detail/tabs/ExpenseReceiptDetailTabHistory.vue';

export default {
  name: 'ExpenseReceiptDetailTabsPanel',
  components: {
    ExpenseReceiptDetailTabDetail,
    ExpenseReceiptDetailTabShipping,
    ExpenseReceiptDetailTabDocuments,
    ExpenseReceiptDetailTabHistory,
  },
  props: {
    activeTab: {
      type: String,
      required: true,
    },
    expenseReceipt: {
      type: Object,
      default: null,
    },
  },
};
</script>
